(() => {
  const tagValue = (tags, prefix) => {
    const tag = (tags || []).find((item) => item.startsWith(prefix));
    return tag ? tag.slice(prefix.length).trim() : '';
  };

  const loadProducts = async () => {
    const products = [];
    for (let page = 1; page <= 4; page += 1) {
      const response = await fetch(`/products.json?limit=250&page=${page}`);
      if (!response.ok) throw new Error('Unable to load shades');
      const batch = (await response.json()).products || [];
      products.push(...batch);
      if (batch.length < 250) break;
    }
    return products;
  };

  const init = async (browser) => {
    if (browser.dataset.ready === 'true') return;
    browser.dataset.ready = 'true';
    const grid = browser.querySelector('.gva-shade-browser__grid');
    const tabs = [...browser.querySelectorAll('.gva-shade-browser__tab')];
    const currentHandle = browser.dataset.currentHandle;
    const currentTexture = browser.dataset.currentTexture;

    try {
      const allProducts = await loadProducts();
      const shades = allProducts
        .filter((product) => product.tags?.includes('GVA Shade'))
        .map((product) => ({
          handle: product.handle,
          title: product.title,
          url: product.url || `/products/${product.handle}`,
          shade: tagValue(product.tags, 'Shade:'),
          category: tagValue(product.tags, 'Shade Category:'),
          texture: tagValue(product.tags, 'Texture:'),
          image: product.images?.[0]?.src || ''
        }))
        .filter((product) => product.texture === currentTexture)
        .sort((a, b) => a.shade.localeCompare(b.shade, undefined, { numeric: true }));

      const render = (category = 'ALL') => {
        const visible = category === 'ALL' ? shades : shades.filter((shade) => shade.category === category);
        grid.innerHTML = '';
        if (!visible.length) {
          grid.innerHTML = '<span class="gva-shade-browser__empty">No shades in this category.</span>';
          return;
        }
        visible.forEach((item) => {
          const link = document.createElement('a');
          link.className = 'gva-shade-browser__swatch';
          link.href = item.url;
          link.title = item.shade;
          link.setAttribute('role', 'listitem');
          if (item.handle === currentHandle) link.setAttribute('aria-current', 'page');
          if (item.image) link.style.backgroundImage = `url(${JSON.stringify(item.image)})`;
          const label = document.createElement('span');
          label.textContent = item.shade;
          link.append(label);
          grid.append(link);
        });
      };

      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        render(tab.dataset.category);
      }));
      render();
    } catch (error) {
      grid.innerHTML = '<span class="gva-shade-browser__empty">Shades could not be loaded. Please refresh the page.</span>';
    }
  };

  const start = () => document.querySelectorAll('[data-gva-shade-browser]').forEach(init);
  document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
  start();
})();
